import { useRef } from "react";
import { useClock } from "../hooks/use-clock";
import * as S from "./styles";
import TimerCommonStack from "../component/stack";
import { calculatePercentage, formatNumber } from "../../../utils/timer";
import AdVideo from "../../../component/AdVideo";
import { useCapture } from "../../../hooks/use-capture";
import { CaptureButton } from "../../../component/CaptureButton";
import { useCopyTournamentText } from "../../../hooks/use-copy-tournament-text";
import { Helmet } from "react-helmet";
import TimerPrizeAndNotice from "../component/prize-and-notice";

const UserTimer3 = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { handleCapture } = useCapture();
  const { copyTournamentText } = useCopyTournamentText();
  const radius = 491;
  const circumference = 2 * Math.PI * radius;

  const {
    timeInfo,
    userCount,
    reBuyInUserCount,
    entryUserCount,
    adOnUserCount,
    stack,
    avgStack,
    pub,
    coverImage,
    backgroundImage,
    isAd,
    setIsAd,
    data,
    visibleRanks,
    getNextBlind,
    getNowBlind,
    getData,
    subPrizeFont,
  } = useClock();

  return (
    <>
      <Helmet>
        <title>{data?.title}</title>
      </Helmet>
      <S.UserTimeWrapper2 ref={containerRef}>
        {backgroundImage && (
          <S.Timer2Background backgroundImage={backgroundImage} />
        )}
        <S.Timer2TimeContainer>
          <S.Circle2
            break={
              timeInfo.currentLevel?.type === "BREAK" &&
              timeInfo.elapsedTimeMs &&
              timeInfo.elapsedTimeMs > 0
                ? true
                : false
            }
          >
            <circle className="background" r={492} cx="506" cy="506" />
            <circle
              className="progress"
              r={492}
              cx="506"
              cy="506"
              strokeDasharray={circumference}
              strokeDashoffset={
                timeInfo.currentLevel &&
                timeInfo.remainingTimeInCurrentLevelMs &&
                timeInfo.elapsedTimeMs &&
                timeInfo.elapsedTimeMs > 0
                  ? circumference -
                    (timeInfo.remainingTimeInCurrentLevelMs /
                      (timeInfo.currentLevel?.time * 60000)) *
                      circumference
                  : 0
              }
            />
          </S.Circle2>
          <div className="dash-wrapper">
            <img
              src={
                timeInfo.currentLevel?.type === "LEVEL" &&
                timeInfo.elapsedTimeMs &&
                timeInfo.elapsedTimeMs > 0
                  ? "/image-web/timer/dash-progress.png"
                  : "/image-web/timer/break-dash-progress.png"
              }
              alt="dash"
            />
            <S.CircularProgress2
              progress={
                timeInfo.currentLevel && timeInfo.remainingTimeInCurrentLevelMs
                  ? calculatePercentage(
                      timeInfo.remainingTimeInCurrentLevelMs,
                      timeInfo.currentLevel?.time * 60000,
                    ) - 0.4
                  : 0
              }
            />
          </div>
          <div className="timer-box">
            <div className="title-box">
              <div className="pub-name">{pub?.cafeName}</div>
              <div className="header">
                {coverImage && <img src={coverImage} alt="logo" />}
                <div className="info-row">
                  <div className="title">{data?.title}</div>
                  <div className="type">{data?.subTitle}</div>
                </div>
              </div>
            </div>
            <div className="level-break">
              <div
                className={`now-level ${
                  timeInfo.currentLevel?.type === "BREAK" && "break "
                }`}
              >{`${
                timeInfo?.elapsedTimeMs && timeInfo?.elapsedTimeMs > 0
                  ? timeInfo.currentLevel?.type === "LEVEL"
                    ? "현재 " + timeInfo.currentLevel.level + "LV"
                    : "BREAK"
                  : "시작 준비중"
              }`}</div>
              <div
                className={`next-break ${
                  timeInfo.timeUntilNextBreak === "00:00:00" && "end"
                }`}
              >
                NEXT BREAK <span>{timeInfo.timeUntilNextBreak}</span>
              </div>
            </div>

            <div
              className={`time ${
                timeInfo.currentLevel?.type === "LEVEL" &&
                timeInfo?.elapsedTimeMs &&
                timeInfo?.elapsedTimeMs > 0 &&
                "level "
              }`}
            >
              {timeInfo.remainingTimeInCurrentLevel}
            </div>
            <div className="bottom">
              <div className="item">
                <div className="title">레지 마감 레벨</div>
                <div
                  className={`value ${
                    timeInfo.currentLevel?.type === "BREAK" && "break "
                  }`}
                >
                  {data?.registerDeadlineLevel}LV
                </div>
              </div>
              <div className="line" />
              <div className="item">
                <div className="title">총 진행 시간</div>
                <div
                  className={`value2 ${
                    timeInfo.currentLevel?.type === "BREAK" && "break "
                  }`}
                >
                  {timeInfo.elapsedTime}
                </div>
              </div>
            </div>
          </div>
        </S.Timer2TimeContainer>

        <S.Timer2InfoWrapper>
          <TimerPrizeAndNotice
            data={data}
            visibleRanks={visibleRanks}
            subPrizeFont={subPrizeFont}
          />
          <TimerCommonStack
            totalStack={formatNumber(stack)}
            avgStack={formatNumber(avgStack)}
            players={`${userCount} / ${
              adOnUserCount + reBuyInUserCount + entryUserCount
            }`}
          />
        </S.Timer2InfoWrapper>

        <S.Timer2BlindWrapper>
          <S.Timer2Blind>
            <div className="title">NOW BLINDS</div>
            <div className="value">
              <div className="blind">{getNowBlind()}</div>
            </div>
          </S.Timer2Blind>
          <S.Timer2NextBlind>
            <div className="title next">NEXT BLINDS</div>
            <div className="value">
              <div className="blind next">{getNextBlind()}</div>
            </div>
          </S.Timer2NextBlind>
        </S.Timer2BlindWrapper>
        {isAd && (
          <AdVideo
            coverImage={coverImage}
            onClose={() => setIsAd(false)}
            data={data}
            timeInfo={timeInfo}
            stack={stack}
            avgStack={avgStack}
          />
        )}
      </S.UserTimeWrapper2>
      <CaptureButton
        onCapture={() => handleCapture(containerRef.current, "#0b0c2a")}
        onCopyText={() => copyTournamentText(data, timeInfo)}
      />
    </>
  );
};
export default UserTimer3;
